module.exports = __webpack_public_path__ + "static/media/57.4b587ed8.png";